// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Xh1jg","footer":"styles_footer__36hSN"};